// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-286c3737]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.is_in_wechat[data-v-286c3737]{background-color:rgba(0,0,0,.6);font-family:PingFang SC;z-index:9999}.is_in_wechat>img[data-v-286c3737]{margin-left:40%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
